import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Award, TrendingUp, Compass } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To bridge the gap between exceptional talent and world-class opportunities, creating meaningful career connections.'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Our experienced recruiters have deep industry knowledge and extensive networks across multiple sectors.'
    },
    {
      icon: Award,
      title: 'Quality First',
      description: 'We maintain the highest standards in recruitment, ensuring perfect matches for both candidates and employers.'
    },
    {
      icon: Compass,
      title: 'Spectacular',
      description: 'We invite you to explore premium opportunities tailored to your needs.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />

      <div className="py-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-3xl md:text-5xl font-semibold tracking-tight mb-6" data-testid="about-heading">
              About <span className="gradient-text">OceanTech</span>
            </h1>
            <p className="text-lg text-slate-400 max-w-3xl mx-auto leading-relaxed">
              OceanTech connects top‑tier talent with innovative companies worldwide. Since our inception, we have been dedicated to transforming careers and building exceptional teams.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-testid="values-grid">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="glass-card rounded-3xl p-8"
                >
                  <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center mb-6">
                    <Icon className="w-6 h-6 text-cyan-500" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-3">{value.title}</h3>
                  <p className="text-slate-400 leading-relaxed">{value.description}</p>
                </motion.div>
              );
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="glass-card rounded-3xl p-12 text-center"
          >
            <h2 className="text-3xl font-semibold mb-6">Our Story</h2>
            <div className="text-slate-400 leading-relaxed space-y-4 max-w-3xl mx-auto">
              <p>
                Founded with a vision to revolutionize the recruitment industry, OceanTech has grown
                from a small startup to a trusted partner for companies and job seekers worldwide.
              </p>
              <p>
                We believe that the right opportunity can change lives, and the right hire can
                transform businesses. That's why we approach every placement with dedication,
                expertise and a commitment to excellence.
              </p>
              <p>
                Today, we're proud to serve clients across technology, finance, healthcare, and more,
                maintaining our core values of integrity, quality and personalized service.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;